import '.a4{width:100%;}.ssr-plugin'
import '.f9{border-radius:0.75rem;}.ssr-plugin'
import '.fj{border:1px solid var(--palette-blue-300);}.ssr-plugin'
import '.fc{padding:0.5rem 1rem;}.ssr-plugin'
import '.f5{font-size:1.125rem;}.ssr-plugin'
import '.e9{line-height:1.75rem;}.ssr-plugin'
import '.fk{resize:vertical;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { forwardRef } from 'react'

export type MultiLineTextInputProps = {
  value: string
  placeholder?: string
  minHeight?: string
  style?: Style
  setValue: (value: string) => void
}

export const MultiLineTextInput = forwardRef<
  HTMLTextAreaElement,
  MultiLineTextInputProps
>(
  (
    {
      value,
      placeholder,
      minHeight = '6.5rem',
      style,
      setValue,
    }: MultiLineTextInputProps,
    ref,
  ) => {
    return (
      <styled.textarea className="a4 f9 fj fc f5 e9 fk"
        ref={ref}
        style={{
          minHeight: minHeight,
          '&:focus': {
            outline: 'none',
            border: '1px solid var(--brand-secondary)',
          },
          ...style,
        }}
        placeholder={placeholder}
        value={value}
        onChange={(e) => setValue(e.target.value)}
      ></styled.textarea>
    )
  },
)
